import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, StackType, StackWidth, WIDGET } from '@voltmoney/schema';
import { appendURlWithParam, isMobile, setAppHeader } from '../../configs/utils';
import { ACTION } from "../partnerWeb_Dashboard/types";
import { PartnerHeader } from "../partnerWeb_Dashboard/partnerHeader";
import { SideBarBuilderDS } from "../sideNavBar";
import { partnerApi, StoreKey } from "../../configs/api";
import { onChangeTab } from "../collateral/action";
import { openMenu } from "./action";
import { BottomNavBuilderDS } from "../bottomNav";
import { GoToFaq, GoToHome, GoToPhone, GoToWhatsapp } from "../partnerSignUp/actions";
import { handleConnection, onLogoutPress } from "../partnerWeb_Dashboard/actions";
import { DemoVideosLink, PartnerAccountType } from "../../configs/constants";
import { Dimensions } from "react-native";
import { checkIfPartnerDetailsAdded, ShowNewRmContactButton } from '../partnerWeb_Dashboard/utils';
import { getAppHeader } from '../../configs/config';
import AsyncStorage from '@react-native-async-storage/async-storage';
const _isMobile = isMobile();
export const template = async (data, noOfColumns, height, showNewRmContactButton, rmData, isFromMobile) => {
    return ({
        layout: {
            id: ROUTE.DEMO_VIDEOS,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                {
                    id: 'partnerHeader',
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_TOP,
                },
                showNewRmContactButton ? { id: 'rmContactButton', type: WIDGET.RM_CONTACT_LIST, position: POSITION.ABSOLUTE_BOTTOM } : {},
                !isMobile()
                    ? {
                        id: 'sideNav',
                        type: WIDGET.STACK,
                        position: POSITION.NAVBAR_LEFT,
                    }
                    : {},
                { id: 'collateralMainStack', type: WIDGET.STACK },
                isFromMobile ? { id: 'BottomNavContainer', type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM } : {}
            ]
        },
        datastore: {
            rmContactButton: {
                title: 'Contact us',
                rmData,
                handleRmConnection: {
                    routeId: ROUTE.DEMO_VIDEOS,
                    type: ACTION.HANDLE_CONNECTION,
                    payload: {}
                }
            },
            ...await PartnerHeader(ROUTE.DEMO_VIDEOS),
            ...await SideBarBuilderDS(ROUTE.DEMO_VIDEOS),
            ...await BottomNavBuilderDS(ROUTE.DEMO_VIDEOS),
            collateralMainStack: {
                type: StackType.column,
                width: StackWidth.MATCH_PARENT,
                padding: {
                    left: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                    right: _isMobile ? SizeTypeTokens.XL : {}
                },
                widgetItems: [
                    { id: "spaceXXXL", type: WIDGET.SPACE },
                    { id: "demoVideosHeading", type: WIDGET.TEXT },
                    { id: "space16", type: WIDGET.SPACE },
                    { id: "demoVideosList", type: WIDGET.DEMO_VIDEOS_LIST },
                ]
            },
            spaceXXXL: {
                size: SizeTypeTokens.XXXL
            },
            space16: {
                size: SizeTypeTokens.XL
            },
            space32: {
                size: SizeTypeTokens.Size32
            },
            demoVideosHeading: {
                label: 'Demo videos',
                fontSize: FontSizeTokens.LG,
                fontWeight: '600',
                lineHeight: 26,
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Poppins
            },
            sampleCollateralHeading: {
                label: 'Sample collateral',
                fontSize: FontSizeTokens.MD,
                fontWeight: '500',
                lineHeight: 24,
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Inter
            },
            demoVideosList: {
                height: height,
                data: data,
                noOfColumns: noOfColumns
            },
        },
    });
};
export const demoVideosNav = {
    onLoad: async ({ network, openNewTab, instrumentTrack, asyncStorage, getHeight, ...props }) => {
        instrumentTrack("DEMO_VIDEO_PAGE_VIEWED");
        appendURlWithParam('demo_videos');
        await setAppHeader();
        await checkIfPartnerDetailsAdded({ network: network, openNewTab: openNewTab });
        const _user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
        const partnerAccountType = _user?.linkedPartnerAccounts[0]?.partnerAccountType;
        const isFromMobile = isMobile();
        const demoLink = (partnerAccountType === PartnerAccountType.AFFILIATE)
            ? DemoVideosLink.AFFILIATE
            : DemoVideosLink.DEFAULT;
        const demoVideo = await network.get(`${demoLink}`, {});
        const noOfColumns = () => {
            const getScreenWidth = Dimensions.get("window").width;
            if (getScreenWidth) {
                if (getScreenWidth > 1259) {
                    return 3;
                }
                else if (getScreenWidth > 921 && getScreenWidth <= 1258) {
                    return 2;
                }
                else {
                    return 1;
                }
            }
            return 1;
        };
        let showNewRmContactButton = false;
        showNewRmContactButton = await ShowNewRmContactButton();
        const header = await getAppHeader();
        const user = await AsyncStorage.getItem("user_context");
        const userData = await JSON.parse(user);
        const partnerAccountId = userData?.linkedPartnerAccounts[0].accountId;
        const rmContactResponse = await network.get(`${partnerApi.getMappedRMDetails}${partnerAccountId}`, {
            headers: header
        });
        const rmData = rmContactResponse?.data;
        return Promise.resolve(template(demoVideo.data.data, noOfColumns(), getHeight(), showNewRmContactButton, rmData, isFromMobile));
    },
    actions: {
        [ACTION.CHANGE_TAB]: onChangeTab,
        [ACTION.OPEN_MENU]: openMenu,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.GO_TO_WHATSAPP]: GoToWhatsapp,
        [ACTION.LOGOUT]: onLogoutPress,
        [ACTION.HANDLE_CONNECTION]: handleConnection,
    }
};
